import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = () => ({
	// TYPE OF VIEW - LIST / GRID
	searchBarListView: true,
	searchBarGridView: false,
	showActiveButton: true,
	switchviews: false,
	searchTopicTest: "",
	selectedIndGrp: "",
	reportsDetails: {
		topicName: "",
		testName: "",
		topicID: "",
	},
	// value="1">Date
	// value="2">A-Z
	// value="3">Z-A
	// value="4">Duration
	searchBarSort: "",

	// "a" "Public Availability"
	// "b" "Public Unavailability"
	// "c" "Active"
	// "d" "Inactive"
	searchBarFilter: "",

	// Select questions for select and move
	selectLongQuestion: "",
});

//getters
const getters = {
	getSelectedIndGrp: (state) => state.selectedIndGrp,
	getListView: (state) => state.searchBarListView,
	getGridView: (state) => state.searchBarGridView,
	getToggleView: (state) => state.switchviews,
	getSort: (state) => state.searchBarSort,
	getFilter: (state) => state.searchBarFilter,
	getShowActiveButton: (state) => state.showActiveButton,
	getSelectLongQus: (state) => state.selectLongQuestion,
	getSearchTopicTest: (state) => state.searchTopicTest,
	getReportsDetails: (state) => state.reportsDetails,
};

// actions
const actions = {
	async saveView(state, payload) {
		state.commit("saveView", payload);
	},
};

// mutations
const mutations = {
	saveToggleView(state) {
		state.switchviews = !state.switchviews;
	},
	saveSearchTopicTest(state, payload) {
		state.searchTopicTest = payload;
	},
	saveSelectedIndGrp(state, payload) {
		state.selectedIndGrp = payload;
	},

	saveView(state, payload) {
		state.searchBarListView = payload.list;
		state.searchBarGridView = payload.grid;
		state.showActiveButton = payload.showActiveButton;
	},
	saveSort(state, payload) {
		state.searchBarSort = payload;
	},
	saveFilter(state, payload) {
		state.searchBarFilter = payload;
	},
	selectLongQus(state, payload) {
		state.selectLongQuestion = payload;
	},
	saveReportDetails(state, payload) {
		if (payload.topicName) {
			state.reportsDetails.topicName = payload.topicName;
		} else if (payload.testName) {
			state.reportsDetails.testName = payload.testName;
			state.reportsDetails.topicID = payload.topicID;
		}
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
};
